module.exports = __webpack_public_path__ + "static/media/screenshot-transactions.08ec810d.png";